import React from "react";
import { useTranslation } from "react-i18next";

import { FlashscanRiskBreakdownLine } from "@/types/Flashscan";
import "./FlashscanRiskBreakdownRow.scss";

const FILLING_BAR_COLORS = [
  "golden-earth",
  "toasted-almond",
  "dark-spruce",
  "autumn-ember",
  "deep-space-blue",
];

type FlashscanRiskBreakdownRowProps = {
  line: FlashscanRiskBreakdownLine;
  maxAmount: number;
  position: number;
};

export const FlashscanRiskBreakdownRow: React.FC<
  FlashscanRiskBreakdownRowProps
> = ({ line, maxAmount, position }) => {
  const { t } = useTranslation();

  const fillingBarColor =
    FILLING_BAR_COLORS[position % FILLING_BAR_COLORS.length];

  const width = maxAmount > 0 ? (line.amount / maxAmount) * 100 : 0;

  return (
    <div className="flashscan-risk-breakdown-row">
      <div className="flashscan-risk-breakdown-row-header">
        <div className="flashscan-risk-breakdown-row-title">
          {t(`pages.flashscan.rules.${line.errorReason}`)}
        </div>
        <div className="flashscan-risk-breakdown-row-amount">
          {line.amount.toLocaleString("fr-FR")} €
        </div>
      </div>

      <div className="flashscan-risk-breakdown-row-bar">
        <div
          className={`flashscan-risk-breakdown-row-bar-fill ${fillingBarColor}`}
          style={{ width: `${Math.max(0, Math.min(100, width))}%` }}
        />
      </div>
    </div>
  );
};
